module.exports = __webpack_public_path__ + "img/58_11.de2c8de5.png";